<template>
 <v-app>
  <v-alert
   :value="this.$store.getters.getMessage.active"
   dismissible
   :type="this.$store.getters.getMessage.type"
   transition="scale-transition"
   class="ma-0 d-print-none"
   style="border-top: 0px; position: fixed; z-index: 202; width: 100%"
  >
   {{ this.$store.getters.getMessage.description }}
  </v-alert>

  <template v-if="isLoading">
   <div class="text-center">
    <v-overlay :value="isLoading" :opacity="0.02" style="z-index: 210;">
     <v-img contain src="/loader.svg"></v-img>
    </v-overlay>
   </div>
  </template>
  <NavBar class="d-print-none" v-if="this.$store.getters.isAuthenticated" :drawerStatus="drawerStatus" @drawerStatusChange="drawerStatusChange" />
  <Header class="d-print-none" v-if="this.$store.getters.isAuthenticated" @drawerStatus="drawerStatusChange" :drawerStatus="drawerStatus" />

  <v-main style="background-color: #f2f2f2">
   <router-view />
  </v-main>
 </v-app>
</template>

<script>
import Header from "./components/miscComponents/Header";
import NavBar from "./components/miscComponents/NavBar.vue";
export default {
 name: "App",
 components: {
  Header,
  NavBar,
 },
 data() {
  return {
   drawerStatus: null,
  };
 },

 computed: {
  isLoading() {
   return this.$store.state.loading.isLoading;
  },
 },
 methods: {
  drawerStatusChange(value) {
   this.drawerStatus = value;
  },
 },
};
</script>

<style lang="scss">
@import "./style.css";
@import "~ag-grid-community/styles/ag-grid.css";
@import "~ag-grid-community/styles/ag-theme-alpine.css";
@import "~ag-grid-community/styles/ag-theme-balham.css";
@import "~ag-grid-community/styles/ag-theme-material.css";
</style>
